module.exports = __webpack_public_path__ + "media/images/icon-haccps-check-cd670ea54e2d73c93b555644c63e67bf.svg";